import { SelectField, SubmitDialog } from '@roc/ui';
import { useDrawsStore } from '@roc/feature-draws';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';

export const DRAWS_RESOLVED_STAGE = "Wire Sent/Draw Resolved";

export const SetDrawStage = observer(({ loanId, drawId, afterActionExecuted }) => {

  const { drawStore: { drawActionsStore }, drawStore } = useDrawsStore();

  const [stageList, setStageList] = useState([]);

  useEffect(() => {
    const allStages = drawStore?.drawDTO?.draw?.allStagesArray || [];

    const filteredArray = allStages.filter(item => item !== DRAWS_RESOLVED_STAGE).map(item => {
      return { label: item, value: item };
    });
    setStageList(filteredArray);
    drawActionsStore.setNewStage(filteredArray[0]?.value);
  }, []);

  const confirmHandler = () => {
    drawActionsStore.updateDrawStage(drawId, afterActionExecuted);
  }

  return (
    <SubmitDialog
      title="Select a new Draw Stage"
      open={drawActionsStore.isSetDrawStageDialogOpen}
      body={
        <>
          <SelectField
            label='Draw stage dropdown'
            options={stageList}
            testId={'Draw stage dropdown'}
            value={drawActionsStore.newStage}
            onChange={value => drawActionsStore.setNewStage(value)}
            fullWidth
            variant="outlined"
          />
        </>
      }
      handleClose={() => drawActionsStore.setIsSetDrawStageDialogOpen(false)}
      handleOk={confirmHandler}
      cancelButtonText='Cancel'
    />
  );
});
